import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { booleanFormSchema, currencyInput, numericStringFormSchema, urlSchema } from '@/_schemas/generic';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { inventoryVendorUpdateSchema } from './inventory-vendor-mutation-schema';
import { inventoryVendorQuerySchema } from './inventory-vendor-query-schema';

export const inventoryVendorFormSchema = inventoryVendorUpdateSchema.extend({
  url: urlSchema(),
  vendor_id: z.string().min(1),
  sku_label: z.string().min(1),
  account_number: z.string().min(1),
  sku_start_number: numericStringFormSchema().min(1),
  minimum_order_required: booleanFormSchema(),

  tax_id: z.string(),
  credit_limit: currencyInput.formSchema(),

  notes: z.string(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullable(),
  vendor_w9_file: z.array(fileQuerySchema).nullish(),

  ...inventoryVendorQuerySchema.pick({
    addresses: true,
  }).shape,
});

export type InventoryVendorFormSchema = z.infer<typeof inventoryVendorFormSchema>;
